import { GridSize } from '@atoms/GridSlider/GridSlider';
import { useState } from 'react';

export const useGridAnimation = (initial: GridSize) => {
  const [gridSize, setGridSize] = useState<GridSize>(initial);
  const [pending, setPending] = useState<GridSize | null>(null);
  const [isAnimating, setIsAnimating] = useState(false);

  const request = (next: GridSize) => {
    if (next !== gridSize) {
      setPending(next);
      setIsAnimating(true);
    }
  };
  const apply = () => {
    if (pending !== null) {
      setGridSize(pending);
      setPending(null);
      setIsAnimating(false);
    }
  };

  return {
    gridSize,
    pendingGridSize: pending,
    isAnimatingGridChange: isAnimating,
    requestGridSizeChange: request,
    applyPendingGridSize: apply,
  };
};
